//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { optionsTransformer } from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.NLL_MEDICINE_TASKS_SERVICE_URL) {
      throw new Error('NLL_MEDICINE_TASKS_SERVICE_URL must be set in environment');
    }

    return process.env.NLL_MEDICINE_TASKS_SERVICE_URL;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class MartenTenantClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    addCustomer(customerId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/tenants/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCustomer(_response);
        });
    }

    protected processAddCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RecurrencePatternsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    addRecurrencePattern(residentId: string, prescriptionChainId: string, prescriptionId: string, request: AddRecurrencePatternRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/recurrencePatterns";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddRecurrencePattern(_response);
        });
    }

    protected processAddRecurrencePattern(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteRecurrencePattern(residentId: string, prescriptionChainId: string, prescriptionId: string, recurrencePatternId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/recurrencePatterns/{recurrencePatternId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (recurrencePatternId === undefined || recurrencePatternId === null)
            throw new Error("The parameter 'recurrencePatternId' must be defined.");
        url_ = url_.replace("{recurrencePatternId}", encodeURIComponent("" + recurrencePatternId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRecurrencePattern(_response);
        });
    }

    protected processDeleteRecurrencePattern(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PrescriptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    compareWithStoredPrescriptions(residentId: string, request: CompareWithStoredPrescriptionsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<{ [key: string]: DifferenceResponse[]; }> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptions/compare";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompareWithStoredPrescriptions(_response);
        });
    }

    protected processCompareWithStoredPrescriptions(response: Response): Promise<{ [key: string]: DifferenceResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => DifferenceResponse.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: DifferenceResponse[]; }>(null as any);
    }

    getPrescriptionTimeline(residentId: string, prescriptionChainId: string, prescriptionId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionTimelineResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/prescriptions/{prescriptionId}/timeline";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionTimeline(_response);
        });
    }

    protected processGetPrescriptionTimeline(response: Response): Promise<PrescriptionTimelineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionTimelineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionTimelineResponse>(null as any);
    }
}

export class PrescriptionChainClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    addPrescriptionChain(residentId: string, prescriptionChainId: string, addPrescriptionChainRequest: AddPrescriptionChainRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addPrescriptionChainRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPrescriptionChain(_response);
        });
    }

    protected processAddPrescriptionChain(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updatePrescriptionChain(residentId: string, prescriptionChainId: string, request: UpdatePrescriptionChainRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePrescriptionChain(_response);
        });
    }

    protected processUpdatePrescriptionChain(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPrescriptionChainSummaries(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionChainSummaryResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/summary";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainSummaries(_response);
        });
    }

    protected processGetPrescriptionChainSummaries(response: Response): Promise<PrescriptionChainSummaryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionChainSummaryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainSummaryResponse[]>(null as any);
    }
}

export class PrescriptionChainMetadataClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPrescriptionChainsMetadata(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionChainMetadataResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChainsMetadata";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainsMetadata(_response);
        });
    }

    protected processGetPrescriptionChainsMetadata(response: Response): Promise<PrescriptionChainMetadataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionChainMetadataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainMetadataResponse[]>(null as any);
    }

    getPrescriptionChainMetadata(residentId: string, prescriptionChainId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionChainMetadataResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChainsMetadata/{prescriptionChainId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainMetadata(_response);
        });
    }

    protected processGetPrescriptionChainMetadata(response: Response): Promise<PrescriptionChainMetadataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionChainMetadataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainMetadataResponse>(null as any);
    }
}

export class PlanningClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nll-medicine-tasks-dev.sekoia.one", baseUrl);
    }

    getPrescriptionChainPlanning(residentId: string, prescriptionChainId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionChainPlanningResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/prescriptionChains/{prescriptionChainId}/planning";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionChainId === undefined || prescriptionChainId === null)
            throw new Error("The parameter 'prescriptionChainId' must be defined.");
        url_ = url_.replace("{prescriptionChainId}", encodeURIComponent("" + prescriptionChainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionChainPlanning(_response);
        });
    }

    protected processGetPrescriptionChainPlanning(response: Response): Promise<PrescriptionChainPlanningResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionChainPlanningResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionChainPlanningResponse>(null as any);
    }
}

export class AddRecurrencePatternRequest implements IAddRecurrencePatternRequest {
    recurrencePattern!: RecurrencePatternRequest;

    constructor(data?: IAddRecurrencePatternRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurrencePattern = _data["recurrencePattern"] ? RecurrencePatternRequest.fromJS(_data["recurrencePattern"]) : <any>null;
        }
    }

    static fromJS(data: any): AddRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurrencePattern"] = this.recurrencePattern ? this.recurrencePattern.toJSON() : <any>null;
        return data;
    }
}

export interface IAddRecurrencePatternRequest {
    recurrencePattern: RecurrencePatternRequest;
}

export abstract class RecurrencePatternRequest implements IRecurrencePatternRequest {
    start!: moment.Moment;
    end?: moment.Moment | null;
    plannedAdministrations!: PlannedAdministrationRequest[];

    protected _discriminator: string;

    constructor(data?: IRecurrencePatternRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "RecurrencePatternRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>null;
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationRequest.fromJS(item));
            }
            else {
                this.plannedAdministrations = <any>null;
            }
        }
    }

    static fromJS(data: any): RecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DailyRecurrencePatternRequest") {
            let result = new DailyRecurrencePatternRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RecurrencePatternRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["start"] = this.start ? this.start.toISOString() : <any>null;
        data["end"] = this.end ? this.end.toISOString() : <any>null;
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IRecurrencePatternRequest {
    start: moment.Moment;
    end?: moment.Moment | null;
    plannedAdministrations: PlannedAdministrationRequest[];
}

export class PlannedAdministrationRequest implements IPlannedAdministrationRequest {
    plannedTime!: string;
    amount!: number;

    constructor(data?: IPlannedAdministrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedTime = _data["plannedTime"] !== undefined ? _data["plannedTime"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAdministrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedTime"] = this.plannedTime !== undefined ? this.plannedTime : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IPlannedAdministrationRequest {
    plannedTime: string;
    amount: number;
}

export class DailyRecurrencePatternRequest extends RecurrencePatternRequest implements IDailyRecurrencePatternRequest {
    interval!: number;

    constructor(data?: IDailyRecurrencePatternRequest) {
        super(data);
        this._discriminator = "DailyRecurrencePatternRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.interval = _data["interval"] !== undefined ? _data["interval"] : <any>null;
        }
    }

    static fromJS(data: any): DailyRecurrencePatternRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRecurrencePatternRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval !== undefined ? this.interval : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDailyRecurrencePatternRequest extends IRecurrencePatternRequest {
    interval: number;
}

export class DifferenceResponse implements IDifferenceResponse {
    propertyName!: string;

    protected _discriminator: string;

    constructor(data?: IDifferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DifferenceResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : <any>null;
        }
    }

    static fromJS(data: any): DifferenceResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "EnumDifferenceResponse") {
            let result = new EnumDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "EnumListDifferenceResponse") {
            let result = new EnumListDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ObjectDifferenceResponse") {
            let result = new ObjectDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ObjectListDifferenceResponse") {
            let result = new ObjectListDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeDifferenceResponse") {
            let result = new SimpleTypeDifferenceResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeListDifferenceResponse") {
            let result = new SimpleTypeListDifferenceResponse();
            result.init(data);
            return result;
        }
        let result = new DifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : <any>null;
        return data;
    }
}

export interface IDifferenceResponse {
    propertyName: string;
}

export class EnumDifferenceResponse extends DifferenceResponse implements IEnumDifferenceResponse {
    enumName!: string;
    from?: any | null;
    to?: any | null;

    constructor(data?: IEnumDifferenceResponse) {
        super(data);
        this._discriminator = "EnumDifferenceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): EnumDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnumDifferenceResponse extends IDifferenceResponse {
    enumName: string;
    from?: any | null;
    to?: any | null;
}

export class EnumListDifferenceResponse extends DifferenceResponse implements IEnumListDifferenceResponse {
    enumName!: string;
    from!: any[];
    to!: any[];

    constructor(data?: IEnumListDifferenceResponse) {
        super(data);
        if (!data) {
            this.from = [];
            this.to = [];
        }
        this._discriminator = "EnumListDifferenceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : <any>null;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(item);
            }
            else {
                this.from = <any>null;
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            else {
                this.to = <any>null;
            }
        }
    }

    static fromJS(data: any): EnumListDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListDifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : <any>null;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEnumListDifferenceResponse extends IDifferenceResponse {
    enumName: string;
    from: any[];
    to: any[];
}

export class ObjectDifferenceResponse extends DifferenceResponse implements IObjectDifferenceResponse {
    differences!: DifferenceResponse[];

    constructor(data?: IObjectDifferenceResponse) {
        super(data);
        if (!data) {
            this.differences = [];
        }
        this._discriminator = "ObjectDifferenceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["differences"])) {
                this.differences = [] as any;
                for (let item of _data["differences"])
                    this.differences!.push(DifferenceResponse.fromJS(item));
            }
            else {
                this.differences = <any>null;
            }
        }
    }

    static fromJS(data: any): ObjectDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectDifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectDifferenceResponse extends IDifferenceResponse {
    differences: DifferenceResponse[];
}

export class ObjectListDifferenceResponse extends DifferenceResponse implements IObjectListDifferenceResponse {
    propertyType!: PropertyType;
    from!: ObjectListValueResponse[];
    to!: ObjectListValueResponse[];

    constructor(data?: IObjectListDifferenceResponse) {
        super(data);
        if (!data) {
            this.from = [];
            this.to = [];
        }
        this._discriminator = "ObjectListDifferenceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : <any>null;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(ObjectListValueResponse.fromJS(item));
            }
            else {
                this.from = <any>null;
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(ObjectListValueResponse.fromJS(item));
            }
            else {
                this.to = <any>null;
            }
        }
    }

    static fromJS(data: any): ObjectListDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectListDifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectListDifferenceResponse extends IDifferenceResponse {
    propertyType: PropertyType;
    from: ObjectListValueResponse[];
    to: ObjectListValueResponse[];
}

export enum PropertyType {
    SimpleType = "SimpleType",
    Object = "Object",
    SimpleTypeList = "SimpleTypeList",
    ObjectList = "ObjectList",
    Enum = "Enum",
    EnumList = "EnumList",
}

export class ObjectListValueResponse implements IObjectListValueResponse {
    objectProperties!: ObjectListItemResponse[];

    constructor(data?: IObjectListValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.objectProperties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objectProperties"])) {
                this.objectProperties = [] as any;
                for (let item of _data["objectProperties"])
                    this.objectProperties!.push(ObjectListItemResponse.fromJS(item));
            }
            else {
                this.objectProperties = <any>null;
            }
        }
    }

    static fromJS(data: any): ObjectListValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectListValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objectProperties)) {
            data["objectProperties"] = [];
            for (let item of this.objectProperties)
                data["objectProperties"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IObjectListValueResponse {
    objectProperties: ObjectListItemResponse[];
}

export abstract class ObjectListItemResponse implements IObjectListItemResponse {
    propertyName!: string;

    protected _discriminator: string;

    constructor(data?: IObjectListItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ObjectListItemResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : <any>null;
        }
    }

    static fromJS(data: any): ObjectListItemResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ObjectValueResponse") {
            let result = new ObjectValueResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeListResponse") {
            let result = new SimpleTypeListResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SimpleTypeValueResponse") {
            let result = new SimpleTypeValueResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ObjectListResponse") {
            let result = new ObjectListResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "EnumListResponse") {
            let result = new EnumListResponse();
            result.init(data);
            return result;
        }
        if (data["$type"] === "EnumValueResponse") {
            let result = new EnumValueResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ObjectListItemResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : <any>null;
        return data;
    }
}

export interface IObjectListItemResponse {
    propertyName: string;
}

export class ObjectValueResponse extends ObjectListItemResponse implements IObjectValueResponse {
    objectProperties!: ObjectListItemResponse[];

    constructor(data?: IObjectValueResponse) {
        super(data);
        if (!data) {
            this.objectProperties = [];
        }
        this._discriminator = "ObjectValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["objectProperties"])) {
                this.objectProperties = [] as any;
                for (let item of _data["objectProperties"])
                    this.objectProperties!.push(ObjectListItemResponse.fromJS(item));
            }
            else {
                this.objectProperties = <any>null;
            }
        }
    }

    static fromJS(data: any): ObjectValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objectProperties)) {
            data["objectProperties"] = [];
            for (let item of this.objectProperties)
                data["objectProperties"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectValueResponse extends IObjectListItemResponse {
    objectProperties: ObjectListItemResponse[];
}

export class SimpleTypeListResponse extends ObjectListItemResponse implements ISimpleTypeListResponse {
    propertyType!: SimplePropertyType;
    items!: any[];

    constructor(data?: ISimpleTypeListResponse) {
        super(data);
        if (!data) {
            this.items = [];
        }
        this._discriminator = "SimpleTypeListResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): SimpleTypeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeListResponse extends IObjectListItemResponse {
    propertyType: SimplePropertyType;
    items: any[];
}

export enum SimplePropertyType {
    String = "String",
    Byte = "Byte",
    Bool = "Bool",
    DateAndTime = "DateAndTime",
    Time = "Time",
    Date = "Date",
    Number = "Number",
    Decimal = "Decimal",
}

export class SimpleTypeValueResponse extends ObjectListItemResponse implements ISimpleTypeValueResponse {
    propertyType!: SimplePropertyType;
    propertyValue?: any | null;

    constructor(data?: ISimpleTypeValueResponse) {
        super(data);
        this._discriminator = "SimpleTypeValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : <any>null;
            this.propertyValue = _data["propertyValue"] !== undefined ? _data["propertyValue"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleTypeValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        data["propertyValue"] = this.propertyValue !== undefined ? this.propertyValue : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeValueResponse extends IObjectListItemResponse {
    propertyType: SimplePropertyType;
    propertyValue?: any | null;
}

export class ObjectListResponse extends ObjectListItemResponse implements IObjectListResponse {
    objectValues!: ObjectListValueResponse[];

    constructor(data?: IObjectListResponse) {
        super(data);
        if (!data) {
            this.objectValues = [];
        }
        this._discriminator = "ObjectListResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["objectValues"])) {
                this.objectValues = [] as any;
                for (let item of _data["objectValues"])
                    this.objectValues!.push(ObjectListValueResponse.fromJS(item));
            }
            else {
                this.objectValues = <any>null;
            }
        }
    }

    static fromJS(data: any): ObjectListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objectValues)) {
            data["objectValues"] = [];
            for (let item of this.objectValues)
                data["objectValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IObjectListResponse extends IObjectListItemResponse {
    objectValues: ObjectListValueResponse[];
}

export class EnumListResponse extends ObjectListItemResponse implements IEnumListResponse {
    enumName!: string;
    values!: string[];

    constructor(data?: IEnumListResponse) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "EnumListResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): EnumListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEnumListResponse extends IObjectListItemResponse {
    enumName: string;
    values: string[];
}

export class EnumValueResponse extends ObjectListItemResponse implements IEnumValueResponse {
    enumName!: string;
    propertyValue?: any | null;

    constructor(data?: IEnumValueResponse) {
        super(data);
        this._discriminator = "EnumValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enumName = _data["enumName"] !== undefined ? _data["enumName"] : <any>null;
            this.propertyValue = _data["propertyValue"] !== undefined ? _data["propertyValue"] : <any>null;
        }
    }

    static fromJS(data: any): EnumValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnumValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumName"] = this.enumName !== undefined ? this.enumName : <any>null;
        data["propertyValue"] = this.propertyValue !== undefined ? this.propertyValue : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEnumValueResponse extends IObjectListItemResponse {
    enumName: string;
    propertyValue?: any | null;
}

export class SimpleTypeDifferenceResponse extends DifferenceResponse implements ISimpleTypeDifferenceResponse {
    propertyType!: SimplePropertyType;
    from?: any | null;
    to?: any | null;

    constructor(data?: ISimpleTypeDifferenceResponse) {
        super(data);
        this._discriminator = "SimpleTypeDifferenceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : <any>null;
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleTypeDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeDifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeDifferenceResponse extends IDifferenceResponse {
    propertyType: SimplePropertyType;
    from?: any | null;
    to?: any | null;
}

export class SimpleTypeListDifferenceResponse extends DifferenceResponse implements ISimpleTypeListDifferenceResponse {
    propertyType!: SimplePropertyType;
    from!: any[];
    to!: any[];

    constructor(data?: ISimpleTypeListDifferenceResponse) {
        super(data);
        if (!data) {
            this.from = [];
            this.to = [];
        }
        this._discriminator = "SimpleTypeListDifferenceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyType = _data["propertyType"] !== undefined ? _data["propertyType"] : <any>null;
            if (Array.isArray(_data["from"])) {
                this.from = [] as any;
                for (let item of _data["from"])
                    this.from!.push(item);
            }
            else {
                this.from = <any>null;
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            else {
                this.to = <any>null;
            }
        }
    }

    static fromJS(data: any): SimpleTypeListDifferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTypeListDifferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : <any>null;
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleTypeListDifferenceResponse extends IDifferenceResponse {
    propertyType: SimplePropertyType;
    from: any[];
    to: any[];
}

export class CompareWithStoredPrescriptionsRequest implements ICompareWithStoredPrescriptionsRequest {
    prescriptionChainId!: string;
    prescriptions!: PrescriptionDto[];

    constructor(data?: ICompareWithStoredPrescriptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescriptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : <any>null;
            if (Array.isArray(_data["prescriptions"])) {
                this.prescriptions = [] as any;
                for (let item of _data["prescriptions"])
                    this.prescriptions!.push(PrescriptionDto.fromJS(item));
            }
            else {
                this.prescriptions = <any>null;
            }
        }
    }

    static fromJS(data: any): CompareWithStoredPrescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompareWithStoredPrescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : <any>null;
        if (Array.isArray(this.prescriptions)) {
            data["prescriptions"] = [];
            for (let item of this.prescriptions)
                data["prescriptions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ICompareWithStoredPrescriptionsRequest {
    prescriptionChainId: string;
    prescriptions: PrescriptionDto[];
}

export class PrescriptionDto implements IPrescriptionDto {
    id!: string;
    prescriptionChainId!: string;
    version!: number;
    prescriptionFormat!: string;
    isPartOfPrescriptionChain!: boolean;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    medication!: MedicationDto;
    treatmentReason?: string | null;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionDto[];
    practitioner!: PractitionerDto;
    dispenseInformation!: DispenseInformationDto;
    notes!: NoteDto[];
    prescriptionReasons!: PrescriptionReasonDto[];
    medicationDispenses!: MedicationDispenseDto[];

    constructor(data?: IPrescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerDto();
            this.dispenseInformation = new DispenseInformationDto();
            this.notes = [];
            this.prescriptionReasons = [];
            this.medicationDispenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : <any>null;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : <any>null;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : <any>null;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : <any>null;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : <any>null;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoDto.fromJS(_data["priorityInfo"]) : <any>null;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : <any>null;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : <any>null;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : <any>null;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            this.practitioner = _data["practitioner"] ? PractitionerDto.fromJS(_data["practitioner"]) : new PractitionerDto();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationDto.fromJS(_data["dispenseInformation"]) : new DispenseInformationDto();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = <any>null;
            }
            if (Array.isArray(_data["medicationDispenses"])) {
                this.medicationDispenses = [] as any;
                for (let item of _data["medicationDispenses"])
                    this.medicationDispenses!.push(MedicationDispenseDto.fromJS(item));
            }
            else {
                this.medicationDispenses = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : <any>null;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : <any>null;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : <any>null;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : <any>null;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : <any>null;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : <any>null;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : <any>null;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : <any>null;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>null;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : <any>null;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.medicationDispenses)) {
            data["medicationDispenses"] = [];
            for (let item of this.medicationDispenses)
                data["medicationDispenses"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionDto {
    id: string;
    prescriptionChainId: string;
    version: number;
    prescriptionFormat: string;
    isPartOfPrescriptionChain: boolean;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    medication: MedicationDto;
    treatmentReason?: string | null;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionDto[];
    practitioner: PractitionerDto;
    dispenseInformation: DispenseInformationDto;
    notes: NoteDto[];
    prescriptionReasons: PrescriptionReasonDto[];
    medicationDispenses: MedicationDispenseDto[];
}

export class MedicationDto implements IMedicationDto {
    nplPackId?: string | null;
    medicalConsumableId?: string | null;
    nplId?: string | null;
    form?: string | null;
    strength?: string | null;
    interchangeSubstanceGroup?: string | null;
    productName?: string | null;
    packageContainer?: string | null;
    packageDescription?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    amountDescription?: string | null;
    packagingUnit?: string | null;
    manufacturerName?: string | null;
    narcoticClassification?: NarcoticClassificationDto | null;

    constructor(data?: IMedicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nplPackId = _data["nplPackId"] !== undefined ? _data["nplPackId"] : <any>null;
            this.medicalConsumableId = _data["medicalConsumableId"] !== undefined ? _data["medicalConsumableId"] : <any>null;
            this.nplId = _data["nplId"] !== undefined ? _data["nplId"] : <any>null;
            this.form = _data["form"] !== undefined ? _data["form"] : <any>null;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : <any>null;
            this.interchangeSubstanceGroup = _data["interchangeSubstanceGroup"] !== undefined ? _data["interchangeSubstanceGroup"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.packageContainer = _data["packageContainer"] !== undefined ? _data["packageContainer"] : <any>null;
            this.packageDescription = _data["packageDescription"] !== undefined ? _data["packageDescription"] : <any>null;
            this.atcClearText = _data["atcClearText"] !== undefined ? _data["atcClearText"] : <any>null;
            this.atcCode = _data["atcCode"] !== undefined ? _data["atcCode"] : <any>null;
            this.articleSummaryHtml = _data["articleSummaryHtml"] !== undefined ? _data["articleSummaryHtml"] : <any>null;
            this.amountDescription = _data["amountDescription"] !== undefined ? _data["amountDescription"] : <any>null;
            this.packagingUnit = _data["packagingUnit"] !== undefined ? _data["packagingUnit"] : <any>null;
            this.manufacturerName = _data["manufacturerName"] !== undefined ? _data["manufacturerName"] : <any>null;
            this.narcoticClassification = _data["narcoticClassification"] ? NarcoticClassificationDto.fromJS(_data["narcoticClassification"]) : <any>null;
        }
    }

    static fromJS(data: any): MedicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nplPackId"] = this.nplPackId !== undefined ? this.nplPackId : <any>null;
        data["medicalConsumableId"] = this.medicalConsumableId !== undefined ? this.medicalConsumableId : <any>null;
        data["nplId"] = this.nplId !== undefined ? this.nplId : <any>null;
        data["form"] = this.form !== undefined ? this.form : <any>null;
        data["strength"] = this.strength !== undefined ? this.strength : <any>null;
        data["interchangeSubstanceGroup"] = this.interchangeSubstanceGroup !== undefined ? this.interchangeSubstanceGroup : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["packageContainer"] = this.packageContainer !== undefined ? this.packageContainer : <any>null;
        data["packageDescription"] = this.packageDescription !== undefined ? this.packageDescription : <any>null;
        data["atcClearText"] = this.atcClearText !== undefined ? this.atcClearText : <any>null;
        data["atcCode"] = this.atcCode !== undefined ? this.atcCode : <any>null;
        data["articleSummaryHtml"] = this.articleSummaryHtml !== undefined ? this.articleSummaryHtml : <any>null;
        data["amountDescription"] = this.amountDescription !== undefined ? this.amountDescription : <any>null;
        data["packagingUnit"] = this.packagingUnit !== undefined ? this.packagingUnit : <any>null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : <any>null;
        data["narcoticClassification"] = this.narcoticClassification ? this.narcoticClassification.toJSON() : <any>null;
        return data;
    }
}

export interface IMedicationDto {
    nplPackId?: string | null;
    medicalConsumableId?: string | null;
    nplId?: string | null;
    form?: string | null;
    strength?: string | null;
    interchangeSubstanceGroup?: string | null;
    productName?: string | null;
    packageContainer?: string | null;
    packageDescription?: string | null;
    atcClearText?: string | null;
    atcCode?: string | null;
    articleSummaryHtml?: string | null;
    amountDescription?: string | null;
    packagingUnit?: string | null;
    manufacturerName?: string | null;
    narcoticClassification?: NarcoticClassificationDto | null;
}

export class NarcoticClassificationDto implements INarcoticClassificationDto {
    code!: NarcoticClassificationCode;
    text!: string;

    constructor(data?: INarcoticClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): NarcoticClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NarcoticClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface INarcoticClassificationDto {
    code: NarcoticClassificationCode;
    text: string;
}

export enum NarcoticClassificationCode {
    NotNarcotics = "NotNarcotics",
    NotApplicable = "NotApplicable",
    Classification1 = "Classification1",
    Classification2 = "Classification2",
    Classification3 = "Classification3",
    Classification4 = "Classification4",
    Classification5 = "Classification5",
}

export enum PrescriptionStatus {
    Active = "Active",
    OnHold = "OnHold",
    Cancelled = "Cancelled",
    Completed = "Completed",
    Stopped = "Stopped",
}

export class PrescriptionPriorityInfoDto implements IPrescriptionPriorityInfoDto {
    priority!: PrescriptionPriority;
    displayText!: string;

    constructor(data?: IPrescriptionPriorityInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionPriorityInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionPriorityInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        return data;
    }
}

export interface IPrescriptionPriorityInfoDto {
    priority: PrescriptionPriority;
    displayText: string;
}

export enum PrescriptionPriority {
    Urgent = "urgent",
}

export enum PrescriptionType {
    Pharmaceutical = "Pharmaceutical",
    MedicalConsumable = "MedicalConsumable",
}

export class DosageInstructionDto implements IDosageInstructionDto {
    text!: string;
    asNeeded?: boolean | null;
    administeringInstruction?: string | null;
    additionalInstruction?: string | null;
    observandumDose?: boolean | null;
    sequence!: number;
    subSequence?: number | null;
    dosageType?: string | null;
    patientInstruction!: string;
    maxDosePerPeriod?: DosageMaxDosePerPeriodDto | null;
    method?: DosageMethodDto | null;
    site?: DosageSiteDto | null;
    siteQualifier?: DosageSiteQualifierDto | null;
    timing?: DosageTimingDto | null;
    doseAndRate?: DosageDoseAndRateDto | null;
    route?: DosageRouteDto | null;
    medicalDevice?: DosageMedicalDeviceDto | null;

    constructor(data?: IDosageInstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.asNeeded = _data["asNeeded"] !== undefined ? _data["asNeeded"] : <any>null;
            this.administeringInstruction = _data["administeringInstruction"] !== undefined ? _data["administeringInstruction"] : <any>null;
            this.additionalInstruction = _data["additionalInstruction"] !== undefined ? _data["additionalInstruction"] : <any>null;
            this.observandumDose = _data["observandumDose"] !== undefined ? _data["observandumDose"] : <any>null;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : <any>null;
            this.subSequence = _data["subSequence"] !== undefined ? _data["subSequence"] : <any>null;
            this.dosageType = _data["dosageType"] !== undefined ? _data["dosageType"] : <any>null;
            this.patientInstruction = _data["patientInstruction"] !== undefined ? _data["patientInstruction"] : <any>null;
            this.maxDosePerPeriod = _data["maxDosePerPeriod"] ? DosageMaxDosePerPeriodDto.fromJS(_data["maxDosePerPeriod"]) : <any>null;
            this.method = _data["method"] ? DosageMethodDto.fromJS(_data["method"]) : <any>null;
            this.site = _data["site"] ? DosageSiteDto.fromJS(_data["site"]) : <any>null;
            this.siteQualifier = _data["siteQualifier"] ? DosageSiteQualifierDto.fromJS(_data["siteQualifier"]) : <any>null;
            this.timing = _data["timing"] ? DosageTimingDto.fromJS(_data["timing"]) : <any>null;
            this.doseAndRate = _data["doseAndRate"] ? DosageDoseAndRateDto.fromJS(_data["doseAndRate"]) : <any>null;
            this.route = _data["route"] ? DosageRouteDto.fromJS(_data["route"]) : <any>null;
            this.medicalDevice = _data["medicalDevice"] ? DosageMedicalDeviceDto.fromJS(_data["medicalDevice"]) : <any>null;
        }
    }

    static fromJS(data: any): DosageInstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageInstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["asNeeded"] = this.asNeeded !== undefined ? this.asNeeded : <any>null;
        data["administeringInstruction"] = this.administeringInstruction !== undefined ? this.administeringInstruction : <any>null;
        data["additionalInstruction"] = this.additionalInstruction !== undefined ? this.additionalInstruction : <any>null;
        data["observandumDose"] = this.observandumDose !== undefined ? this.observandumDose : <any>null;
        data["sequence"] = this.sequence !== undefined ? this.sequence : <any>null;
        data["subSequence"] = this.subSequence !== undefined ? this.subSequence : <any>null;
        data["dosageType"] = this.dosageType !== undefined ? this.dosageType : <any>null;
        data["patientInstruction"] = this.patientInstruction !== undefined ? this.patientInstruction : <any>null;
        data["maxDosePerPeriod"] = this.maxDosePerPeriod ? this.maxDosePerPeriod.toJSON() : <any>null;
        data["method"] = this.method ? this.method.toJSON() : <any>null;
        data["site"] = this.site ? this.site.toJSON() : <any>null;
        data["siteQualifier"] = this.siteQualifier ? this.siteQualifier.toJSON() : <any>null;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>null;
        data["doseAndRate"] = this.doseAndRate ? this.doseAndRate.toJSON() : <any>null;
        data["route"] = this.route ? this.route.toJSON() : <any>null;
        data["medicalDevice"] = this.medicalDevice ? this.medicalDevice.toJSON() : <any>null;
        return data;
    }
}

export interface IDosageInstructionDto {
    text: string;
    asNeeded?: boolean | null;
    administeringInstruction?: string | null;
    additionalInstruction?: string | null;
    observandumDose?: boolean | null;
    sequence: number;
    subSequence?: number | null;
    dosageType?: string | null;
    patientInstruction: string;
    maxDosePerPeriod?: DosageMaxDosePerPeriodDto | null;
    method?: DosageMethodDto | null;
    site?: DosageSiteDto | null;
    siteQualifier?: DosageSiteQualifierDto | null;
    timing?: DosageTimingDto | null;
    doseAndRate?: DosageDoseAndRateDto | null;
    route?: DosageRouteDto | null;
    medicalDevice?: DosageMedicalDeviceDto | null;
}

export class DosageMaxDosePerPeriodDto implements IDosageMaxDosePerPeriodDto {
    doseValue?: number | null;
    doseUnit?: string | null;
    dosePeriod?: number | null;
    dosePeriodUnit?: string | null;

    constructor(data?: IDosageMaxDosePerPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doseValue = _data["doseValue"] !== undefined ? _data["doseValue"] : <any>null;
            this.doseUnit = _data["doseUnit"] !== undefined ? _data["doseUnit"] : <any>null;
            this.dosePeriod = _data["dosePeriod"] !== undefined ? _data["dosePeriod"] : <any>null;
            this.dosePeriodUnit = _data["dosePeriodUnit"] !== undefined ? _data["dosePeriodUnit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageMaxDosePerPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMaxDosePerPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doseValue"] = this.doseValue !== undefined ? this.doseValue : <any>null;
        data["doseUnit"] = this.doseUnit !== undefined ? this.doseUnit : <any>null;
        data["dosePeriod"] = this.dosePeriod !== undefined ? this.dosePeriod : <any>null;
        data["dosePeriodUnit"] = this.dosePeriodUnit !== undefined ? this.dosePeriodUnit : <any>null;
        return data;
    }
}

export interface IDosageMaxDosePerPeriodDto {
    doseValue?: number | null;
    doseUnit?: string | null;
    dosePeriod?: number | null;
    dosePeriodUnit?: string | null;
}

export class DosageMethodDto implements IDosageMethodDto {
    method!: string;
    otherMethodDescription?: string | null;

    constructor(data?: IDosageMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
            this.otherMethodDescription = _data["otherMethodDescription"] !== undefined ? _data["otherMethodDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["otherMethodDescription"] = this.otherMethodDescription !== undefined ? this.otherMethodDescription : <any>null;
        return data;
    }
}

export interface IDosageMethodDto {
    method: string;
    otherMethodDescription?: string | null;
}

export class DosageSiteDto implements IDosageSiteDto {
    site!: string;
    otherSiteDescription?: string | null;

    constructor(data?: IDosageSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] !== undefined ? _data["site"] : <any>null;
            this.otherSiteDescription = _data["otherSiteDescription"] !== undefined ? _data["otherSiteDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site !== undefined ? this.site : <any>null;
        data["otherSiteDescription"] = this.otherSiteDescription !== undefined ? this.otherSiteDescription : <any>null;
        return data;
    }
}

export interface IDosageSiteDto {
    site: string;
    otherSiteDescription?: string | null;
}

export class DosageSiteQualifierDto implements IDosageSiteQualifierDto {
    siteQualifier!: string;
    otherSiteQualifierDescription?: string | null;

    constructor(data?: IDosageSiteQualifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteQualifier = _data["siteQualifier"] !== undefined ? _data["siteQualifier"] : <any>null;
            this.otherSiteQualifierDescription = _data["otherSiteQualifierDescription"] !== undefined ? _data["otherSiteQualifierDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageSiteQualifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageSiteQualifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteQualifier"] = this.siteQualifier !== undefined ? this.siteQualifier : <any>null;
        data["otherSiteQualifierDescription"] = this.otherSiteQualifierDescription !== undefined ? this.otherSiteQualifierDescription : <any>null;
        return data;
    }
}

export interface IDosageSiteQualifierDto {
    siteQualifier: string;
    otherSiteQualifierDescription?: string | null;
}

export class DosageTimingDto implements IDosageTimingDto {
    bounds?: DosageBoundsDto | null;
    duration?: number | null;
    durationUnit?: string | null;
    subSequenceDuration?: number | null;
    subSequenceDurationUnit?: string | null;
    daysOfWeek!: DayOfWeek[];
    periodsOfDay!: string[];
    timesOfDay!: string[];

    constructor(data?: IDosageTimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.daysOfWeek = [];
            this.periodsOfDay = [];
            this.timesOfDay = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bounds = _data["bounds"] ? DosageBoundsDto.fromJS(_data["bounds"]) : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.durationUnit = _data["durationUnit"] !== undefined ? _data["durationUnit"] : <any>null;
            this.subSequenceDuration = _data["subSequenceDuration"] !== undefined ? _data["subSequenceDuration"] : <any>null;
            this.subSequenceDurationUnit = _data["subSequenceDurationUnit"] !== undefined ? _data["subSequenceDurationUnit"] : <any>null;
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            else {
                this.daysOfWeek = <any>null;
            }
            if (Array.isArray(_data["periodsOfDay"])) {
                this.periodsOfDay = [] as any;
                for (let item of _data["periodsOfDay"])
                    this.periodsOfDay!.push(item);
            }
            else {
                this.periodsOfDay = <any>null;
            }
            if (Array.isArray(_data["timesOfDay"])) {
                this.timesOfDay = [] as any;
                for (let item of _data["timesOfDay"])
                    this.timesOfDay!.push(item);
            }
            else {
                this.timesOfDay = <any>null;
            }
        }
    }

    static fromJS(data: any): DosageTimingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageTimingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bounds"] = this.bounds ? this.bounds.toJSON() : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["durationUnit"] = this.durationUnit !== undefined ? this.durationUnit : <any>null;
        data["subSequenceDuration"] = this.subSequenceDuration !== undefined ? this.subSequenceDuration : <any>null;
        data["subSequenceDurationUnit"] = this.subSequenceDurationUnit !== undefined ? this.subSequenceDurationUnit : <any>null;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        if (Array.isArray(this.periodsOfDay)) {
            data["periodsOfDay"] = [];
            for (let item of this.periodsOfDay)
                data["periodsOfDay"].push(item);
        }
        if (Array.isArray(this.timesOfDay)) {
            data["timesOfDay"] = [];
            for (let item of this.timesOfDay)
                data["timesOfDay"].push(item);
        }
        return data;
    }
}

export interface IDosageTimingDto {
    bounds?: DosageBoundsDto | null;
    duration?: number | null;
    durationUnit?: string | null;
    subSequenceDuration?: number | null;
    subSequenceDurationUnit?: string | null;
    daysOfWeek: DayOfWeek[];
    periodsOfDay: string[];
    timesOfDay: string[];
}

export abstract class DosageBoundsDto implements IDosageBoundsDto {

    protected _discriminator: string;

    constructor(data?: IDosageBoundsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DosageBoundsDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DosageBoundsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "BoundsDurationDto") {
            let result = new BoundsDurationDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoundsRangeDto") {
            let result = new BoundsRangeDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DosageBoundsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface IDosageBoundsDto {
}

export class BoundsDurationDto extends DosageBoundsDto implements IBoundsDurationDto {
    value!: number;
    unit!: string;

    constructor(data?: IBoundsDurationDto) {
        super(data);
        this._discriminator = "BoundsDurationDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): BoundsDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoundsDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBoundsDurationDto extends IDosageBoundsDto {
    value: number;
    unit: string;
}

export class BoundsRangeDto extends DosageBoundsDto implements IBoundsRangeDto {
    minValue!: number;
    maxValue!: number;
    minUnit!: string;
    maxUnit!: string;

    constructor(data?: IBoundsRangeDto) {
        super(data);
        this._discriminator = "BoundsRangeDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : <any>null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : <any>null;
            this.minUnit = _data["minUnit"] !== undefined ? _data["minUnit"] : <any>null;
            this.maxUnit = _data["maxUnit"] !== undefined ? _data["maxUnit"] : <any>null;
        }
    }

    static fromJS(data: any): BoundsRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoundsRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : <any>null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : <any>null;
        data["minUnit"] = this.minUnit !== undefined ? this.minUnit : <any>null;
        data["maxUnit"] = this.maxUnit !== undefined ? this.maxUnit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBoundsRangeDto extends IDosageBoundsDto {
    minValue: number;
    maxValue: number;
    minUnit: string;
    maxUnit: string;
}

export enum DayOfWeek {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export class DosageDoseAndRateDto implements IDosageDoseAndRateDto {
    rate?: DosageRateDto | null;
    dose?: DosageDoseDto | null;

    constructor(data?: IDosageDoseAndRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"] ? DosageRateDto.fromJS(_data["rate"]) : <any>null;
            this.dose = _data["dose"] ? DosageDoseDto.fromJS(_data["dose"]) : <any>null;
        }
    }

    static fromJS(data: any): DosageDoseAndRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseAndRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate ? this.rate.toJSON() : <any>null;
        data["dose"] = this.dose ? this.dose.toJSON() : <any>null;
        return data;
    }
}

export interface IDosageDoseAndRateDto {
    rate?: DosageRateDto | null;
    dose?: DosageDoseDto | null;
}

export class DosageRateDto implements IDosageRateDto {
    value?: number | null;
    unit!: string;

    constructor(data?: IDosageRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data;
    }
}

export interface IDosageRateDto {
    value?: number | null;
    unit: string;
}

export abstract class DosageDoseDto implements IDosageDoseDto {

    protected _discriminator: string;

    constructor(data?: IDosageDoseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DosageDoseDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DosageDoseDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DosageDoseRangeDto") {
            let result = new DosageDoseRangeDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DosageDoseQuantityDto") {
            let result = new DosageDoseQuantityDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DosageDoseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface IDosageDoseDto {
}

export class DosageDoseRangeDto extends DosageDoseDto implements IDosageDoseRangeDto {
    minValue!: number;
    maxValue!: number;
    minUnit!: string;
    maxUnit!: string;

    constructor(data?: IDosageDoseRangeDto) {
        super(data);
        this._discriminator = "DosageDoseRangeDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : <any>null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : <any>null;
            this.minUnit = _data["minUnit"] !== undefined ? _data["minUnit"] : <any>null;
            this.maxUnit = _data["maxUnit"] !== undefined ? _data["maxUnit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageDoseRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : <any>null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : <any>null;
        data["minUnit"] = this.minUnit !== undefined ? this.minUnit : <any>null;
        data["maxUnit"] = this.maxUnit !== undefined ? this.maxUnit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageDoseRangeDto extends IDosageDoseDto {
    minValue: number;
    maxValue: number;
    minUnit: string;
    maxUnit: string;
}

export class DosageDoseQuantityDto extends DosageDoseDto implements IDosageDoseQuantityDto {
    value?: number | null;
    unit?: string | null;

    constructor(data?: IDosageDoseQuantityDto) {
        super(data);
        this._discriminator = "DosageDoseQuantityDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DosageDoseQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageDoseQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDosageDoseQuantityDto extends IDosageDoseDto {
    value?: number | null;
    unit?: string | null;
}

export class DosageRouteDto implements IDosageRouteDto {
    route!: string;
    otherRouteDescription?: string | null;

    constructor(data?: IDosageRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route = _data["route"] !== undefined ? _data["route"] : <any>null;
            this.otherRouteDescription = _data["otherRouteDescription"] !== undefined ? _data["otherRouteDescription"] : <any>null;
        }
    }

    static fromJS(data: any): DosageRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route"] = this.route !== undefined ? this.route : <any>null;
        data["otherRouteDescription"] = this.otherRouteDescription !== undefined ? this.otherRouteDescription : <any>null;
        return data;
    }
}

export interface IDosageRouteDto {
    route: string;
    otherRouteDescription?: string | null;
}

export class DosageMedicalDeviceDto implements IDosageMedicalDeviceDto {
    otherDescription?: string | null;
    displayText?: string | null;

    constructor(data?: IDosageMedicalDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otherDescription = _data["otherDescription"] !== undefined ? _data["otherDescription"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
        }
    }

    static fromJS(data: any): DosageMedicalDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DosageMedicalDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otherDescription"] = this.otherDescription !== undefined ? this.otherDescription : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        return data;
    }
}

export interface IDosageMedicalDeviceDto {
    otherDescription?: string | null;
    displayText?: string | null;
}

export abstract class PersonDto implements IPersonDto {
    fullName?: string | null;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PersonDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }
}

export interface IPersonDto {
    fullName?: string | null;
}

export class PractitionerDto extends PersonDto implements IPractitionerDto {
    phones!: TelecomDto[];
    role?: string | null;
    workplaceName?: string | null;
    addresses!: AddressDto[];

    constructor(data?: IPractitionerDto) {
        super(data);
        if (!data) {
            this.phones = [];
            this.addresses = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(TelecomDto.fromJS(item));
            }
            else {
                this.phones = <any>null;
            }
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.workplaceName = _data["workplaceName"] !== undefined ? _data["workplaceName"] : <any>null;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressDto.fromJS(item));
            }
            else {
                this.addresses = <any>null;
            }
        }
    }

    static fromJS(data: any): PractitionerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PractitionerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item ? item.toJSON() : <any>null);
        }
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["workplaceName"] = this.workplaceName !== undefined ? this.workplaceName : <any>null;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPractitionerDto extends IPersonDto {
    phones: TelecomDto[];
    role?: string | null;
    workplaceName?: string | null;
    addresses: AddressDto[];
}

export class TelecomDto implements ITelecomDto {
    phoneNumber!: string;
    availableToPatient!: boolean;
    contactPointType?: string | null;

    constructor(data?: ITelecomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.availableToPatient = _data["availableToPatient"] !== undefined ? _data["availableToPatient"] : <any>null;
            this.contactPointType = _data["contactPointType"] !== undefined ? _data["contactPointType"] : <any>null;
        }
    }

    static fromJS(data: any): TelecomDto {
        data = typeof data === 'object' ? data : {};
        let result = new TelecomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["availableToPatient"] = this.availableToPatient !== undefined ? this.availableToPatient : <any>null;
        data["contactPointType"] = this.contactPointType !== undefined ? this.contactPointType : <any>null;
        return data;
    }
}

export interface ITelecomDto {
    phoneNumber: string;
    availableToPatient: boolean;
    contactPointType?: string | null;
}

export class AddressDto implements IAddressDto {
    addressType?: AddressType | null;
    line?: string[] | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : <any>null;
            if (Array.isArray(_data["line"])) {
                this.line = [] as any;
                for (let item of _data["line"])
                    this.line!.push(item);
            }
            else {
                this.line = <any>null;
            }
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressType"] = this.addressType !== undefined ? this.addressType : <any>null;
        if (Array.isArray(this.line)) {
            data["line"] = [];
            for (let item of this.line)
                data["line"].push(item);
        }
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        return data;
    }
}

export interface IAddressDto {
    addressType?: AddressType | null;
    line?: string[] | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
}

export enum AddressType {
    Physical = "Physical",
    Postal = "Postal",
    Both = "Both",
}

export class DispenseInformationDto implements IDispenseInformationDto {
    hasTrialDispense!: boolean;
    patientIsEligibleForPharmaceuticalBenefitsAct!: boolean;
    prescriptionIsAccordingToCommunicableDiseasesAct?: boolean | null;
    patientFulfillsConditionsPharmaceuticalBenefitsAct?: boolean | null;
    lastDateOfValidity?: moment.Moment | null;
    firstDispenseBefore?: moment.Moment | null;
    numberOfPackagesPrescribed?: number | null;
    remainingQuantity?: number | null;
    numberOfFillsRemaining?: number | null;
    numberOfDispensesAllowed?: number | null;
    dispenseInterval?: DispenseIntervalDto | null;
    substitutionOpposed?: string | null;
    dosePackaging!: boolean;

    constructor(data?: IDispenseInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTrialDispense = _data["hasTrialDispense"] !== undefined ? _data["hasTrialDispense"] : <any>null;
            this.patientIsEligibleForPharmaceuticalBenefitsAct = _data["patientIsEligibleForPharmaceuticalBenefitsAct"] !== undefined ? _data["patientIsEligibleForPharmaceuticalBenefitsAct"] : <any>null;
            this.prescriptionIsAccordingToCommunicableDiseasesAct = _data["prescriptionIsAccordingToCommunicableDiseasesAct"] !== undefined ? _data["prescriptionIsAccordingToCommunicableDiseasesAct"] : <any>null;
            this.patientFulfillsConditionsPharmaceuticalBenefitsAct = _data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] !== undefined ? _data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] : <any>null;
            this.lastDateOfValidity = _data["lastDateOfValidity"] ? moment(_data["lastDateOfValidity"].toString()) : <any>null;
            this.firstDispenseBefore = _data["firstDispenseBefore"] ? moment(_data["firstDispenseBefore"].toString()) : <any>null;
            this.numberOfPackagesPrescribed = _data["numberOfPackagesPrescribed"] !== undefined ? _data["numberOfPackagesPrescribed"] : <any>null;
            this.remainingQuantity = _data["remainingQuantity"] !== undefined ? _data["remainingQuantity"] : <any>null;
            this.numberOfFillsRemaining = _data["numberOfFillsRemaining"] !== undefined ? _data["numberOfFillsRemaining"] : <any>null;
            this.numberOfDispensesAllowed = _data["numberOfDispensesAllowed"] !== undefined ? _data["numberOfDispensesAllowed"] : <any>null;
            this.dispenseInterval = _data["dispenseInterval"] ? DispenseIntervalDto.fromJS(_data["dispenseInterval"]) : <any>null;
            this.substitutionOpposed = _data["substitutionOpposed"] !== undefined ? _data["substitutionOpposed"] : <any>null;
            this.dosePackaging = _data["dosePackaging"] !== undefined ? _data["dosePackaging"] : <any>null;
        }
    }

    static fromJS(data: any): DispenseInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTrialDispense"] = this.hasTrialDispense !== undefined ? this.hasTrialDispense : <any>null;
        data["patientIsEligibleForPharmaceuticalBenefitsAct"] = this.patientIsEligibleForPharmaceuticalBenefitsAct !== undefined ? this.patientIsEligibleForPharmaceuticalBenefitsAct : <any>null;
        data["prescriptionIsAccordingToCommunicableDiseasesAct"] = this.prescriptionIsAccordingToCommunicableDiseasesAct !== undefined ? this.prescriptionIsAccordingToCommunicableDiseasesAct : <any>null;
        data["patientFulfillsConditionsPharmaceuticalBenefitsAct"] = this.patientFulfillsConditionsPharmaceuticalBenefitsAct !== undefined ? this.patientFulfillsConditionsPharmaceuticalBenefitsAct : <any>null;
        data["lastDateOfValidity"] = this.lastDateOfValidity ? this.lastDateOfValidity.format('YYYY-MM-DD') : <any>null;
        data["firstDispenseBefore"] = this.firstDispenseBefore ? this.firstDispenseBefore.format('YYYY-MM-DD') : <any>null;
        data["numberOfPackagesPrescribed"] = this.numberOfPackagesPrescribed !== undefined ? this.numberOfPackagesPrescribed : <any>null;
        data["remainingQuantity"] = this.remainingQuantity !== undefined ? this.remainingQuantity : <any>null;
        data["numberOfFillsRemaining"] = this.numberOfFillsRemaining !== undefined ? this.numberOfFillsRemaining : <any>null;
        data["numberOfDispensesAllowed"] = this.numberOfDispensesAllowed !== undefined ? this.numberOfDispensesAllowed : <any>null;
        data["dispenseInterval"] = this.dispenseInterval ? this.dispenseInterval.toJSON() : <any>null;
        data["substitutionOpposed"] = this.substitutionOpposed !== undefined ? this.substitutionOpposed : <any>null;
        data["dosePackaging"] = this.dosePackaging !== undefined ? this.dosePackaging : <any>null;
        return data;
    }
}

export interface IDispenseInformationDto {
    hasTrialDispense: boolean;
    patientIsEligibleForPharmaceuticalBenefitsAct: boolean;
    prescriptionIsAccordingToCommunicableDiseasesAct?: boolean | null;
    patientFulfillsConditionsPharmaceuticalBenefitsAct?: boolean | null;
    lastDateOfValidity?: moment.Moment | null;
    firstDispenseBefore?: moment.Moment | null;
    numberOfPackagesPrescribed?: number | null;
    remainingQuantity?: number | null;
    numberOfFillsRemaining?: number | null;
    numberOfDispensesAllowed?: number | null;
    dispenseInterval?: DispenseIntervalDto | null;
    substitutionOpposed?: string | null;
    dosePackaging: boolean;
}

export class DispenseIntervalDto implements IDispenseIntervalDto {
    value!: number;
    unit!: string;

    constructor(data?: IDispenseIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): DispenseIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new DispenseIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data;
    }
}

export interface IDispenseIntervalDto {
    value: number;
    unit: string;
}

export class NoteDto implements INoteDto {
    noteType!: NoteType;
    noteTypeDisplayText!: string;
    textMarkdown!: string;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            this.noteTypeDisplayText = _data["noteTypeDisplayText"] !== undefined ? _data["noteTypeDisplayText"] : <any>null;
            this.textMarkdown = _data["textMarkdown"] !== undefined ? _data["textMarkdown"] : <any>null;
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        data["noteTypeDisplayText"] = this.noteTypeDisplayText !== undefined ? this.noteTypeDisplayText : <any>null;
        data["textMarkdown"] = this.textMarkdown !== undefined ? this.textMarkdown : <any>null;
        return data;
    }
}

export interface INoteDto {
    noteType: NoteType;
    noteTypeDisplayText: string;
    textMarkdown: string;
}

export enum NoteType {
    PrescriberToCare = "PrescriberToCare",
    PrescriberToPharmacy = "PrescriberToPharmacy",
    Pharmacy = "Pharmacy",
    Delivery = "Delivery",
}

export class PrescriptionReasonDto implements IPrescriptionReasonDto {
    isAbsent!: boolean;
    description?: string | null;
    displayText!: string;

    constructor(data?: IPrescriptionReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAbsent = _data["isAbsent"] !== undefined ? _data["isAbsent"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.displayText = _data["displayText"] !== undefined ? _data["displayText"] : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAbsent"] = this.isAbsent !== undefined ? this.isAbsent : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["displayText"] = this.displayText !== undefined ? this.displayText : <any>null;
        return data;
    }
}

export interface IPrescriptionReasonDto {
    isAbsent: boolean;
    description?: string | null;
    displayText: string;
}

export class MedicationDispenseDto implements IMedicationDispenseDto {
    id!: string;
    version!: number;
    authorizingPrescriptionId!: string;
    authorizingPrescriptionVersion!: number;
    expeditionTime?: moment.Moment | null;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    wasSubstituted!: boolean;
    dispenseType!: string;
    benefitChoice!: string;
    noteMarkdown?: string | null;
    status!: MedicationDispenseStatusType;
    dosageInstructions!: DosageInstructionDto[];
    medication!: MedicationDto;

    constructor(data?: IMedicationDispenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dosageInstructions = [];
            this.medication = new MedicationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.authorizingPrescriptionId = _data["authorizingPrescriptionId"] !== undefined ? _data["authorizingPrescriptionId"] : <any>null;
            this.authorizingPrescriptionVersion = _data["authorizingPrescriptionVersion"] !== undefined ? _data["authorizingPrescriptionVersion"] : <any>null;
            this.expeditionTime = _data["expeditionTime"] ? moment(_data["expeditionTime"].toString()) : <any>null;
            this.creditTime = _data["creditTime"] ? moment(_data["creditTime"].toString()) : <any>null;
            this.numberOfPackagesDispensed = _data["numberOfPackagesDispensed"] !== undefined ? _data["numberOfPackagesDispensed"] : <any>null;
            this.expeditionQuantity = _data["expeditionQuantity"] !== undefined ? _data["expeditionQuantity"] : <any>null;
            this.wasSubstituted = _data["wasSubstituted"] !== undefined ? _data["wasSubstituted"] : <any>null;
            this.dispenseType = _data["dispenseType"] !== undefined ? _data["dispenseType"] : <any>null;
            this.benefitChoice = _data["benefitChoice"] !== undefined ? _data["benefitChoice"] : <any>null;
            this.noteMarkdown = _data["noteMarkdown"] !== undefined ? _data["noteMarkdown"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
        }
    }

    static fromJS(data: any): MedicationDispenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDispenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["authorizingPrescriptionId"] = this.authorizingPrescriptionId !== undefined ? this.authorizingPrescriptionId : <any>null;
        data["authorizingPrescriptionVersion"] = this.authorizingPrescriptionVersion !== undefined ? this.authorizingPrescriptionVersion : <any>null;
        data["expeditionTime"] = this.expeditionTime ? this.expeditionTime.toISOString() : <any>null;
        data["creditTime"] = this.creditTime ? this.creditTime.toISOString() : <any>null;
        data["numberOfPackagesDispensed"] = this.numberOfPackagesDispensed !== undefined ? this.numberOfPackagesDispensed : <any>null;
        data["expeditionQuantity"] = this.expeditionQuantity !== undefined ? this.expeditionQuantity : <any>null;
        data["wasSubstituted"] = this.wasSubstituted !== undefined ? this.wasSubstituted : <any>null;
        data["dispenseType"] = this.dispenseType !== undefined ? this.dispenseType : <any>null;
        data["benefitChoice"] = this.benefitChoice !== undefined ? this.benefitChoice : <any>null;
        data["noteMarkdown"] = this.noteMarkdown !== undefined ? this.noteMarkdown : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        return data;
    }
}

export interface IMedicationDispenseDto {
    id: string;
    version: number;
    authorizingPrescriptionId: string;
    authorizingPrescriptionVersion: number;
    expeditionTime?: moment.Moment | null;
    creditTime?: moment.Moment | null;
    numberOfPackagesDispensed?: number | null;
    expeditionQuantity?: number | null;
    wasSubstituted: boolean;
    dispenseType: string;
    benefitChoice: string;
    noteMarkdown?: string | null;
    status: MedicationDispenseStatusType;
    dosageInstructions: DosageInstructionDto[];
    medication: MedicationDto;
}

export enum MedicationDispenseStatusType {
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export class PrescriptionTimelineResponse implements IPrescriptionTimelineResponse {
    prescriptionId!: string;
    entries!: PrescriptionTimelineEntryResponse[];

    constructor(data?: IPrescriptionTimelineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(PrescriptionTimelineEntryResponse.fromJS(item));
            }
            else {
                this.entries = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionTimelineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionTimelineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionTimelineResponse {
    prescriptionId: string;
    entries: PrescriptionTimelineEntryResponse[];
}

export class PrescriptionTimelineEntryResponse implements IPrescriptionTimelineEntryResponse {
    differences!: DifferenceResponse[];
    timestamp!: moment.Moment;
    employeeId!: string;

    constructor(data?: IPrescriptionTimelineEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.differences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["differences"])) {
                this.differences = [] as any;
                for (let item of _data["differences"])
                    this.differences!.push(DifferenceResponse.fromJS(item));
            }
            else {
                this.differences = <any>null;
            }
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionTimelineEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionTimelineEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item ? item.toJSON() : <any>null);
        }
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        return data;
    }
}

export interface IPrescriptionTimelineEntryResponse {
    differences: DifferenceResponse[];
    timestamp: moment.Moment;
    employeeId: string;
}

export class AddPrescriptionChainRequest implements IAddPrescriptionChainRequest {
    prescriptionDtos!: PrescriptionDto[];

    constructor(data?: IAddPrescriptionChainRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescriptionDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prescriptionDtos"])) {
                this.prescriptionDtos = [] as any;
                for (let item of _data["prescriptionDtos"])
                    this.prescriptionDtos!.push(PrescriptionDto.fromJS(item));
            }
            else {
                this.prescriptionDtos = <any>null;
            }
        }
    }

    static fromJS(data: any): AddPrescriptionChainRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPrescriptionChainRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prescriptionDtos)) {
            data["prescriptionDtos"] = [];
            for (let item of this.prescriptionDtos)
                data["prescriptionDtos"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IAddPrescriptionChainRequest {
    prescriptionDtos: PrescriptionDto[];
}

export class PrescriptionChainSummaryResponse implements IPrescriptionChainSummaryResponse {
    id!: string;
    residentId!: string;
    hasParallelPrescriptions!: boolean;
    hasUnplannedPrescriptions!: boolean;
    latestPrescription!: PrescriptionResponse;

    constructor(data?: IPrescriptionChainSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.latestPrescription = new PrescriptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.hasParallelPrescriptions = _data["hasParallelPrescriptions"] !== undefined ? _data["hasParallelPrescriptions"] : <any>null;
            this.hasUnplannedPrescriptions = _data["hasUnplannedPrescriptions"] !== undefined ? _data["hasUnplannedPrescriptions"] : <any>null;
            this.latestPrescription = _data["latestPrescription"] ? PrescriptionResponse.fromJS(_data["latestPrescription"]) : new PrescriptionResponse();
        }
    }

    static fromJS(data: any): PrescriptionChainSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["hasParallelPrescriptions"] = this.hasParallelPrescriptions !== undefined ? this.hasParallelPrescriptions : <any>null;
        data["hasUnplannedPrescriptions"] = this.hasUnplannedPrescriptions !== undefined ? this.hasUnplannedPrescriptions : <any>null;
        data["latestPrescription"] = this.latestPrescription ? this.latestPrescription.toJSON() : <any>null;
        return data;
    }
}

export interface IPrescriptionChainSummaryResponse {
    id: string;
    residentId: string;
    hasParallelPrescriptions: boolean;
    hasUnplannedPrescriptions: boolean;
    latestPrescription: PrescriptionResponse;
}

export class PrescriptionResponse implements IPrescriptionResponse {
    id!: string;
    version!: number;
    prescriptionFormat!: string;
    isPartOfPrescriptionChain!: boolean;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    medication!: MedicationDto;
    treatmentReason?: string | null;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionDto[];
    practitioner!: PractitionerDto;
    dispenseInformation!: DispenseInformationDto;
    notes!: NoteDto[];
    prescriptionReasons!: PrescriptionReasonDto[];

    constructor(data?: IPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerDto();
            this.dispenseInformation = new DispenseInformationDto();
            this.notes = [];
            this.prescriptionReasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : <any>null;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : <any>null;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : <any>null;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : <any>null;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : <any>null;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoDto.fromJS(_data["priorityInfo"]) : <any>null;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : <any>null;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : <any>null;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : <any>null;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            this.practitioner = _data["practitioner"] ? PractitionerDto.fromJS(_data["practitioner"]) : new PractitionerDto();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationDto.fromJS(_data["dispenseInformation"]) : new DispenseInformationDto();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : <any>null;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : <any>null;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : <any>null;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : <any>null;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : <any>null;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : <any>null;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : <any>null;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : <any>null;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>null;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : <any>null;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionResponse {
    id: string;
    version: number;
    prescriptionFormat: string;
    isPartOfPrescriptionChain: boolean;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    medication: MedicationDto;
    treatmentReason?: string | null;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionDto[];
    practitioner: PractitionerDto;
    dispenseInformation: DispenseInformationDto;
    notes: NoteDto[];
    prescriptionReasons: PrescriptionReasonDto[];
}

export class UpdatePrescriptionChainRequest implements IUpdatePrescriptionChainRequest {
    upsertedPrescriptions!: UpsertPrescriptionRequest[];
    upsertedMedicationDispenses!: MedicationDispenseDto[];

    constructor(data?: IUpdatePrescriptionChainRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.upsertedPrescriptions = [];
            this.upsertedMedicationDispenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["upsertedPrescriptions"])) {
                this.upsertedPrescriptions = [] as any;
                for (let item of _data["upsertedPrescriptions"])
                    this.upsertedPrescriptions!.push(UpsertPrescriptionRequest.fromJS(item));
            }
            else {
                this.upsertedPrescriptions = <any>null;
            }
            if (Array.isArray(_data["upsertedMedicationDispenses"])) {
                this.upsertedMedicationDispenses = [] as any;
                for (let item of _data["upsertedMedicationDispenses"])
                    this.upsertedMedicationDispenses!.push(MedicationDispenseDto.fromJS(item));
            }
            else {
                this.upsertedMedicationDispenses = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdatePrescriptionChainRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrescriptionChainRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.upsertedPrescriptions)) {
            data["upsertedPrescriptions"] = [];
            for (let item of this.upsertedPrescriptions)
                data["upsertedPrescriptions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.upsertedMedicationDispenses)) {
            data["upsertedMedicationDispenses"] = [];
            for (let item of this.upsertedMedicationDispenses)
                data["upsertedMedicationDispenses"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IUpdatePrescriptionChainRequest {
    upsertedPrescriptions: UpsertPrescriptionRequest[];
    upsertedMedicationDispenses: MedicationDispenseDto[];
}

export class UpsertPrescriptionRequest implements IUpsertPrescriptionRequest {
    prescriptionId!: string;
    prescriptionDetails!: PrescriptionDetailsRequest;

    constructor(data?: IUpsertPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescriptionDetails = new PrescriptionDetailsRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.prescriptionDetails = _data["prescriptionDetails"] ? PrescriptionDetailsRequest.fromJS(_data["prescriptionDetails"]) : new PrescriptionDetailsRequest();
        }
    }

    static fromJS(data: any): UpsertPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["prescriptionDetails"] = this.prescriptionDetails ? this.prescriptionDetails.toJSON() : <any>null;
        return data;
    }
}

export interface IUpsertPrescriptionRequest {
    prescriptionId: string;
    prescriptionDetails: PrescriptionDetailsRequest;
}

export class PrescriptionDetailsRequest implements IPrescriptionDetailsRequest {
    version!: number;
    prescriptionFormat!: string;
    isPartOfPrescriptionChain!: boolean;
    authoredOn!: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis!: string;
    medication!: MedicationDto;
    treatmentReason?: string | null;
    status!: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType!: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed!: boolean;
    dosageInstructions!: DosageInstructionDto[];
    practitioner!: PractitionerDto;
    dispenseInformation!: DispenseInformationDto;
    notes!: NoteDto[];
    prescriptionReasons!: PrescriptionReasonDto[];

    constructor(data?: IPrescriptionDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.dosageInstructions = [];
            this.practitioner = new PractitionerDto();
            this.dispenseInformation = new DispenseInformationDto();
            this.notes = [];
            this.prescriptionReasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.prescriptionFormat = _data["prescriptionFormat"] !== undefined ? _data["prescriptionFormat"] : <any>null;
            this.isPartOfPrescriptionChain = _data["isPartOfPrescriptionChain"] !== undefined ? _data["isPartOfPrescriptionChain"] : <any>null;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : <any>null;
            this.treatmentReviewDate = _data["treatmentReviewDate"] ? moment(_data["treatmentReviewDate"].toString()) : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.registrationBasis = _data["registrationBasis"] !== undefined ? _data["registrationBasis"] : <any>null;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            this.treatmentReason = _data["treatmentReason"] !== undefined ? _data["treatmentReason"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.statusReason = _data["statusReason"] !== undefined ? _data["statusReason"] : <any>null;
            this.priorityInfo = _data["priorityInfo"] ? PrescriptionPriorityInfoDto.fromJS(_data["priorityInfo"]) : <any>null;
            this.prescriptionType = _data["prescriptionType"] !== undefined ? _data["prescriptionType"] : <any>null;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : <any>null;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : <any>null;
            this.substitutionAllowed = _data["substitutionAllowed"] !== undefined ? _data["substitutionAllowed"] : <any>null;
            if (Array.isArray(_data["dosageInstructions"])) {
                this.dosageInstructions = [] as any;
                for (let item of _data["dosageInstructions"])
                    this.dosageInstructions!.push(DosageInstructionDto.fromJS(item));
            }
            else {
                this.dosageInstructions = <any>null;
            }
            this.practitioner = _data["practitioner"] ? PractitionerDto.fromJS(_data["practitioner"]) : new PractitionerDto();
            this.dispenseInformation = _data["dispenseInformation"] ? DispenseInformationDto.fromJS(_data["dispenseInformation"]) : new DispenseInformationDto();
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(NoteDto.fromJS(item));
            }
            else {
                this.notes = <any>null;
            }
            if (Array.isArray(_data["prescriptionReasons"])) {
                this.prescriptionReasons = [] as any;
                for (let item of _data["prescriptionReasons"])
                    this.prescriptionReasons!.push(PrescriptionReasonDto.fromJS(item));
            }
            else {
                this.prescriptionReasons = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["prescriptionFormat"] = this.prescriptionFormat !== undefined ? this.prescriptionFormat : <any>null;
        data["isPartOfPrescriptionChain"] = this.isPartOfPrescriptionChain !== undefined ? this.isPartOfPrescriptionChain : <any>null;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : <any>null;
        data["treatmentReviewDate"] = this.treatmentReviewDate ? this.treatmentReviewDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["registrationBasis"] = this.registrationBasis !== undefined ? this.registrationBasis : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        data["treatmentReason"] = this.treatmentReason !== undefined ? this.treatmentReason : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["statusReason"] = this.statusReason !== undefined ? this.statusReason : <any>null;
        data["priorityInfo"] = this.priorityInfo ? this.priorityInfo.toJSON() : <any>null;
        data["prescriptionType"] = this.prescriptionType !== undefined ? this.prescriptionType : <any>null;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : <any>null;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : <any>null;
        data["substitutionAllowed"] = this.substitutionAllowed !== undefined ? this.substitutionAllowed : <any>null;
        if (Array.isArray(this.dosageInstructions)) {
            data["dosageInstructions"] = [];
            for (let item of this.dosageInstructions)
                data["dosageInstructions"].push(item ? item.toJSON() : <any>null);
        }
        data["practitioner"] = this.practitioner ? this.practitioner.toJSON() : <any>null;
        data["dispenseInformation"] = this.dispenseInformation ? this.dispenseInformation.toJSON() : <any>null;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.prescriptionReasons)) {
            data["prescriptionReasons"] = [];
            for (let item of this.prescriptionReasons)
                data["prescriptionReasons"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionDetailsRequest {
    version: number;
    prescriptionFormat: string;
    isPartOfPrescriptionChain: boolean;
    authoredOn: moment.Moment;
    treatmentReviewDate?: moment.Moment | null;
    treatmentEndDate?: moment.Moment | null;
    registrationBasis: string;
    medication: MedicationDto;
    treatmentReason?: string | null;
    status: PrescriptionStatus;
    statusReason?: string | null;
    priorityInfo?: PrescriptionPriorityInfoDto | null;
    prescriptionType: PrescriptionType;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    substitutionAllowed: boolean;
    dosageInstructions: DosageInstructionDto[];
    practitioner: PractitionerDto;
    dispenseInformation: DispenseInformationDto;
    notes: NoteDto[];
    prescriptionReasons: PrescriptionReasonDto[];
}

export class PrescriptionChainMetadataResponse implements IPrescriptionChainMetadataResponse {
    prescriptionChainId!: string;
    created!: moment.Moment;
    prescriptionsMetadata!: PrescriptionMetadataResponse[];

    constructor(data?: IPrescriptionChainMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescriptionsMetadata = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : <any>null;
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>null;
            if (Array.isArray(_data["prescriptionsMetadata"])) {
                this.prescriptionsMetadata = [] as any;
                for (let item of _data["prescriptionsMetadata"])
                    this.prescriptionsMetadata!.push(PrescriptionMetadataResponse.fromJS(item));
            }
            else {
                this.prescriptionsMetadata = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionChainMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        if (Array.isArray(this.prescriptionsMetadata)) {
            data["prescriptionsMetadata"] = [];
            for (let item of this.prescriptionsMetadata)
                data["prescriptionsMetadata"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionChainMetadataResponse {
    prescriptionChainId: string;
    created: moment.Moment;
    prescriptionsMetadata: PrescriptionMetadataResponse[];
}

export class PrescriptionMetadataResponse implements IPrescriptionMetadataResponse {
    prescriptionId!: string;
    prescriptionVersion!: number;
    lastUpdatedAt!: moment.Moment;
    lastUpdatedBy!: string;
    medicationDispensesMetadata!: MedicationDispenseMetadataResponse[];

    constructor(data?: IPrescriptionMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicationDispensesMetadata = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.prescriptionVersion = _data["prescriptionVersion"] !== undefined ? _data["prescriptionVersion"] : <any>null;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>null;
            this.lastUpdatedBy = _data["lastUpdatedBy"] !== undefined ? _data["lastUpdatedBy"] : <any>null;
            if (Array.isArray(_data["medicationDispensesMetadata"])) {
                this.medicationDispensesMetadata = [] as any;
                for (let item of _data["medicationDispensesMetadata"])
                    this.medicationDispensesMetadata!.push(MedicationDispenseMetadataResponse.fromJS(item));
            }
            else {
                this.medicationDispensesMetadata = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["prescriptionVersion"] = this.prescriptionVersion !== undefined ? this.prescriptionVersion : <any>null;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>null;
        data["lastUpdatedBy"] = this.lastUpdatedBy !== undefined ? this.lastUpdatedBy : <any>null;
        if (Array.isArray(this.medicationDispensesMetadata)) {
            data["medicationDispensesMetadata"] = [];
            for (let item of this.medicationDispensesMetadata)
                data["medicationDispensesMetadata"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionMetadataResponse {
    prescriptionId: string;
    prescriptionVersion: number;
    lastUpdatedAt: moment.Moment;
    lastUpdatedBy: string;
    medicationDispensesMetadata: MedicationDispenseMetadataResponse[];
}

export class MedicationDispenseMetadataResponse implements IMedicationDispenseMetadataResponse {
    id!: string;
    version!: number;

    constructor(data?: IMedicationDispenseMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): MedicationDispenseMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDispenseMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IMedicationDispenseMetadataResponse {
    id: string;
    version: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class PrescriptionChainPlanningResponse implements IPrescriptionChainPlanningResponse {
    prescriptionChainId!: string;
    prescriptionPlannings!: PrescriptionPlanningResponse[];

    constructor(data?: IPrescriptionChainPlanningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescriptionPlannings = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionChainId = _data["prescriptionChainId"] !== undefined ? _data["prescriptionChainId"] : <any>null;
            if (Array.isArray(_data["prescriptionPlannings"])) {
                this.prescriptionPlannings = [] as any;
                for (let item of _data["prescriptionPlannings"])
                    this.prescriptionPlannings!.push(PrescriptionPlanningResponse.fromJS(item));
            }
            else {
                this.prescriptionPlannings = <any>null;
            }
        }
    }

    static fromJS(data: any): PrescriptionChainPlanningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionChainPlanningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionChainId"] = this.prescriptionChainId !== undefined ? this.prescriptionChainId : <any>null;
        if (Array.isArray(this.prescriptionPlannings)) {
            data["prescriptionPlannings"] = [];
            for (let item of this.prescriptionPlannings)
                data["prescriptionPlannings"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPrescriptionChainPlanningResponse {
    prescriptionChainId: string;
    prescriptionPlannings: PrescriptionPlanningResponse[];
}

export class PrescriptionPlanningResponse implements IPrescriptionPlanningResponse {
    prescriptionId!: string;
    authoredOn!: moment.Moment;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    status!: PrescriptionStatus;
    medication!: MedicationDto;
    medicationDispenses!: MedicationDispenseDto[];
    planning?: PlanningResponse | null;

    constructor(data?: IPrescriptionPlanningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medication = new MedicationDto();
            this.medicationDispenses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.authoredOn = _data["authoredOn"] ? moment(_data["authoredOn"].toString()) : <any>null;
            this.usageStartDate = _data["usageStartDate"] ? moment(_data["usageStartDate"].toString()) : <any>null;
            this.usageEndDate = _data["usageEndDate"] ? moment(_data["usageEndDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.medication = _data["medication"] ? MedicationDto.fromJS(_data["medication"]) : new MedicationDto();
            if (Array.isArray(_data["medicationDispenses"])) {
                this.medicationDispenses = [] as any;
                for (let item of _data["medicationDispenses"])
                    this.medicationDispenses!.push(MedicationDispenseDto.fromJS(item));
            }
            else {
                this.medicationDispenses = <any>null;
            }
            this.planning = _data["planning"] ? PlanningResponse.fromJS(_data["planning"]) : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionPlanningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionPlanningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["authoredOn"] = this.authoredOn ? this.authoredOn.toISOString() : <any>null;
        data["usageStartDate"] = this.usageStartDate ? this.usageStartDate.format('YYYY-MM-DD') : <any>null;
        data["usageEndDate"] = this.usageEndDate ? this.usageEndDate.format('YYYY-MM-DD') : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>null;
        if (Array.isArray(this.medicationDispenses)) {
            data["medicationDispenses"] = [];
            for (let item of this.medicationDispenses)
                data["medicationDispenses"].push(item ? item.toJSON() : <any>null);
        }
        data["planning"] = this.planning ? this.planning.toJSON() : <any>null;
        return data;
    }
}

export interface IPrescriptionPlanningResponse {
    prescriptionId: string;
    authoredOn: moment.Moment;
    usageStartDate?: moment.Moment | null;
    usageEndDate?: moment.Moment | null;
    status: PrescriptionStatus;
    medication: MedicationDto;
    medicationDispenses: MedicationDispenseDto[];
    planning?: PlanningResponse | null;
}

export class PlanningResponse implements IPlanningResponse {
    id!: string;
    recurrencePatterns!: RecurrencePatternResponse[];

    constructor(data?: IPlanningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recurrencePatterns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["recurrencePatterns"])) {
                this.recurrencePatterns = [] as any;
                for (let item of _data["recurrencePatterns"])
                    this.recurrencePatterns!.push(RecurrencePatternResponse.fromJS(item));
            }
            else {
                this.recurrencePatterns = <any>null;
            }
        }
    }

    static fromJS(data: any): PlanningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.recurrencePatterns)) {
            data["recurrencePatterns"] = [];
            for (let item of this.recurrencePatterns)
                data["recurrencePatterns"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPlanningResponse {
    id: string;
    recurrencePatterns: RecurrencePatternResponse[];
}

export abstract class RecurrencePatternResponse implements IRecurrencePatternResponse {
    id!: string;
    start!: moment.Moment;
    end?: moment.Moment | null;
    plannedAdministrations!: PlannedAdministrationResponse[];

    protected _discriminator: string;

    constructor(data?: IRecurrencePatternResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.plannedAdministrations = [];
        }
        this._discriminator = "RecurrencePatternResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>null;
            if (Array.isArray(_data["plannedAdministrations"])) {
                this.plannedAdministrations = [] as any;
                for (let item of _data["plannedAdministrations"])
                    this.plannedAdministrations!.push(PlannedAdministrationResponse.fromJS(item));
            }
            else {
                this.plannedAdministrations = <any>null;
            }
        }
    }

    static fromJS(data: any): RecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "DailyRecurrencePatternResponse") {
            let result = new DailyRecurrencePatternResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RecurrencePatternResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["start"] = this.start ? this.start.toISOString() : <any>null;
        data["end"] = this.end ? this.end.toISOString() : <any>null;
        if (Array.isArray(this.plannedAdministrations)) {
            data["plannedAdministrations"] = [];
            for (let item of this.plannedAdministrations)
                data["plannedAdministrations"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IRecurrencePatternResponse {
    id: string;
    start: moment.Moment;
    end?: moment.Moment | null;
    plannedAdministrations: PlannedAdministrationResponse[];
}

export class PlannedAdministrationResponse implements IPlannedAdministrationResponse {
    plannedTime!: string;
    amount!: number;

    constructor(data?: IPlannedAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedTime = _data["plannedTime"] !== undefined ? _data["plannedTime"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedTime"] = this.plannedTime !== undefined ? this.plannedTime : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

export interface IPlannedAdministrationResponse {
    plannedTime: string;
    amount: number;
}

export class DailyRecurrencePatternResponse extends RecurrencePatternResponse implements IDailyRecurrencePatternResponse {
    interval!: number;

    constructor(data?: IDailyRecurrencePatternResponse) {
        super(data);
        this._discriminator = "DailyRecurrencePatternResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.interval = _data["interval"] !== undefined ? _data["interval"] : <any>null;
        }
    }

    static fromJS(data: any): DailyRecurrencePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRecurrencePatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval !== undefined ? this.interval : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDailyRecurrencePatternResponse extends IRecurrencePatternResponse {
    interval: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}